import { mapLetStatements } from "./let";
import { mapSetStatements } from "./set";
import { mapDeclareParameters } from "./parameters";
import { mapQueryExpression } from "./expression";
export function mapQuery(node, ctx) {
    const letStatementsResult = mapLetStatements(node, ctx);
    if (!Array.isArray(letStatementsResult))
        return letStatementsResult;
    const setStatements = mapSetStatements(node, ctx);
    const declareParameters = mapDeclareParameters(node, ctx);
    const queryExprNode = ctx.getChild(node, "QueryExpression");
    if (!queryExprNode) {
        return ctx.errorNode(node, "Query missing QueryExpression");
    }
    const expression = mapQueryExpression(queryExprNode, ctx);
    if (expression.type === "ErrorNode")
        return expression;
    const query = {
        type: "Query",
        letStatements: letStatementsResult,
        setStatements,
        declareParameters,
        expression,
        start: node.from,
        end: node.to,
    };
    if (expression.type === "PipelineExpression") {
        query.pipeline = expression;
    }
    return query;
}
